import * as React from 'react';
import { JSX } from 'react';

export const IncludeDisabledCheckbox = ({ includeDisabledCheckbox }: { includeDisabledCheckbox?: JSX.Element }) => {
  if (!includeDisabledCheckbox) {
    return null;
  }

  return <div className="row">
    <div className="col-12 text-end">
      {includeDisabledCheckbox}
    </div>
  </div>;
};
